import { render, staticRenderFns } from "./svgDialog.vue?vue&type=template&id=70935586&scoped=true&"
import script from "./svgDialog.vue?vue&type=script&lang=js&"
export * from "./svgDialog.vue?vue&type=script&lang=js&"
import style0 from "./svgDialog.vue?vue&type=style&index=0&id=70935586&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70935586",
  null
  
)

export default component.exports